import O1HD, {modules, services} from "../../engines/gameEngine";
import gameConfig from "../../engines/configs/gameConfig";
import {REWARD_TYPE} from "../../engines/services/userContent/userInterface";
import data_control from "../../engines/libs/data_control";


const {ccclass, property} = cc._decorator;

@ccclass
export default class power extends cc.Component {

    @property(cc.Label)
    lbPower: cc.Label = null;

    @property(cc.Label)
    lbResetPower: cc.Label = null;

    @property(cc.Prefab)
    InfinityPower: cc.Prefab = null;

    // LIFE-CYCLE CALLBACKS:
    private readonly InfinityPower_Key: string = 'user-logintime';
    private readonly InfinityModel: string = 'user-is-infinity';

    private readonly m_MemberTimeKey: string = "user-membertime";

    protected start() {
        this.onUpdateTimer()
        this.schedule(this.onUpdateTimer.bind(this), 1);
    }

    onUpdateTimer() {
        const currPower = O1HD.getServices().userSrv.getPower();
        const maxPower = O1HD.getServices().userSrv.getMaxPower();
        let resetTime = services().userSrv.getPowerResetTimer();
        resetTime = Math.max(0, resetTime);
        //体力已满
        if (currPower >= maxPower) {
            this.lbPower.string = `${currPower}`;
            //
            this.lbResetPower.string = "00:00"
        } else {//体力还有得恢复
            this.lbPower.string = `${currPower}/${maxPower}`;
            //
            this.lbResetPower.string = data_control.getTimeFormatClock(resetTime);
            //恢复
            services().userSrv.onPowerTimerReset();
        }

        //判断无限体力是否过期
        let dateNow = Date.now();
        let dateOld = O1HD.getServices().localStorageSrv.getStorage(this.InfinityPower_Key)
        if (dateOld) {
            if (dateNow - Number(dateOld) >= 86400 * 1e3)//如果大于24小时
            {
                if (Number(O1HD.getServices().localStorageSrv.getStorage(this.InfinityModel)) != 0) {
                    O1HD.getServices().userSrv.setPower(gameConfig.MAX_POWER, false, true)
                }
                O1HD.getServices().localStorageSrv.setStorage(this.InfinityModel, 0)
                O1HD.getServices().localStorageSrv.setStorage(this.InfinityPower_Key, dateNow)
                O1HD.getModules().uiControlModule.showInfinityPower(gameConfig.FIRST_PLAY_INFINITY_PROBABILITY, O1HD.Canvas());
            }
        } else//如果是第一次进入游戏
        {
            O1HD.getServices().localStorageSrv.setStorage(this.InfinityModel, 0)
            O1HD.getServices().localStorageSrv.setStorage(this.InfinityPower_Key, dateNow)
            O1HD.getModules().uiControlModule.showInfinityPower(gameConfig.FIRST_PLAY_INFINITY_PROBABILITY, O1HD.Canvas());
        }
    }

    onBtnAddPower() {
        O1HD.getManagers().soundMgr.playSound('anNiu').then();
        // modules().uiControlModule.showUserPropGet(REWARD_TYPE.POWER, gameConfig.ADD_ONCE_POWER);
        modules().uiControlModule.showUserPropGet(REWARD_TYPE.POWER, gameConfig.ADD_ONCE_POWER, null, () => {
            O1HD.getModules().uiControlModule.showInfinityPower(gameConfig.CLICK_POWER_INFINITY_PROBABILITY, O1HD.Canvas());
        });
    }


    update(dt) {
    }
}
